export const metatagimapaserwisu = {
  Page: {
    "meta-tagi": {
      Title: "SkiOne.pl - mapa serwisu",
      Description:
        "Mapa serwisu SkiOne.pl. Wszystkie linki, strony i podstrony portalu SkiOne.pl. Pełna mapa serwisu ::: Zaplanuj idealne wakacje z Grupą Portali TravelOne.pl!",
      Keywords: []
    }
  }
};
